<div class="initiative-chip-wraper" *ngIf="industriesList.length">
    <span class="initiative-chip"
        *ngFor="let industry of industriesList | slice:0:displayNumber">{{industry.name}}</span>
    <ng-container *ngIf="moreSegments > 0">
        <span class="initiative-chip initiative-chip-more" (click)="open()" appStopPropagation i18n>+{{moreSegments}}
            more</span>
    </ng-container>
</div>